var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"attachment",staticClass:"border rounded",attrs:{"type":"file","id":"attachment"},on:{"change":function($event){return _vm.upload()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }